import type { UserPoliciesList } from "@keystone-ui/types";

import { capitalizeEachWord } from "utils";
import { getPolicyTypeLabel } from "utils/policy-type-labels";

export const WIND_DEFENSE_OFFER_INTERNAL_NAME = "wind-defense";

export function formatWindDefensePolicyCardStreet(
  policy: UserPoliciesList[0],
): string {
  const street1 = policy.propertyAddress?.street1;
  if (!street1) return "Unknown address";
  const street2 = policy.propertyAddress?.street2;
  return capitalizeEachWord([street1, street2].filter(Boolean).join(", "));
}

export function formatWindDefensePolicyCardSubtitle(
  policy: UserPoliciesList[0],
): string {
  const typeLabel = getPolicyTypeLabel(policy.policyType);
  return typeLabel
    ? `${typeLabel} #${policy.platformPolicyId}`
    : `Policy #${policy.platformPolicyId}`;
}

export function windDefensePolicyCardUiIcon(
  policy: UserPoliciesList[0],
): "Home" | "MixedUse" | "Store" {
  if (policy.isCommercial) return "Store";
  if (policy.policyType === "HO6") return "MixedUse";
  return "Home";
}
